<template>
  <div class="home_page">
    <template v-if="$route.name === 'storeSpare'">
      <Breadcrumb :pageTitle="pageTitle" />
      <div class="storeSpare_console">
        <!-- 轮播图 -->
        <div class="lclb_swiper">
          <el-carousel height="344px">
            <el-carousel-item v-for="(item, index) in swiperList" :key="index">
              <img :src="item.url" alt="" width="100%" height="344px" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="lclb_padding">
          <div class="lclb_title">备件数据大盘</div>
          <el-row :gutter="20">
            <el-col :span="8" v-for="item in dataMarkets" :key="item.name">
              <div class="data_market">
                <div
                  class="data_market_img"
                  :style="{ background: 'url(' + item.bgurl + ')' }"
                >
                  <img :src="item.img" alt="" class="flex-shrink" />
                </div>
                <div class="data_market_content">
                  <div class="data_market_content_detail">
                    <div class="market_name">{{ item.name }}</div>
                    <div class="market_num">{{ item.num }}</div>
                    <div
                      class="market_status"
                      :class="{ 'top-color': item.rate >= 0 }"
                    >
                      <i
                        :class="{
                          'el-icon-caret-top': item.rate >= 0,
                          'el-icon-caret-bottom': item.rate < 0
                        }"
                      ></i>
                      {{ item.rate }}%
                      <font class="market_compare">同比上周</font>
                    </div>
                  </div>
                  <div class="agreement">
                    <span @click="jumpRoute(item.routeName)">详情</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 备件核心指标概览 -->
          <el-card class="box-card">
            <div class="lclb_title">备件核心指标概览</div>
            <el-row>
              <el-col
                :span="12"
                v-for="(item, index) in coreList"
                :key="item.name"
              >
                <div class="core_item">
                  <div class="data_market_content_detail">
                    <div class="market_name">{{ item.name }}</div>
                    <div class="market_num">{{ item.num }}</div>
                    <div
                      class="market_status"
                      :class="{ 'top-color': item.rate >= 0 }"
                    >
                      <i
                        :class="{
                          'el-icon-caret-top': item.rate >= 0,
                          'el-icon-caret-bottom': item.rate < 0
                        }"
                      ></i>
                      {{ item.rate }}%
                      <font class="market_compare">同比上月</font>
                    </div>
                  </div>
                  <div :ref="'core' + index" style="height: 100px;"></div>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <!-- 备件Top -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-card class="box-card">
                <div class="lclb_title">
                  <span>备件Top 10</span>
                </div>
                <div ref="sparePart" style="height: 283px;"></div>
              </el-card>
            </el-col>
          </el-row>
          <!-- 备件分布 -->
          <div class="lclb_title" style="margin:20px">备件分布</div>
          <el-card class="box-card">
            <china-map :dataList="dataList" style="background: #fff;" />
          </el-card>
        </div>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>
<script>
import Breadcrumb from '@/components/breadcrumb/index'
import ChinaMap from './chinaMap'
const echarts = require('echarts')
export default {
  components: {
    Breadcrumb,
    ChinaMap
  },
  data () {
    return {
      pageTitle: [
        {
          label: '首页',
          url: '/'
        },
        {
          label: '联储联备',
          url: '/storeSpare'
        },
        {
          label: '数据大盘'
        }
      ],
      swiperList: [
        // {
        //   url: require('@/assets/img/lclb/u4811.png')
        // }
      ], // 轮播图列表
      // 数据大盘
      dataMarkets: [
        {
          img: require('@/assets/img/lclb/u4661.svg'),
          bgurl: require('@/assets/img/lclb/u4660.svg'),
          name: '备件需求(单)',
          num: 0,
          rate: 0,
          routeName: 'spareRequirementsList'
        },
        {
          img: require('@/assets/img/lclb/u4673.svg'),
          bgurl: require('@/assets/img/lclb/u4672.svg'),
          name: '备件库存数(件)',
          num: 0,
          rate: 0,
          routeName: 'sparePartsLibrary'
        },
        {
          img: require('@/assets/img/lclb/u4679.svg'),
          bgurl: require('@/assets/img/lclb/u4678.svg'),
          name: '备件领用(单)',
          num: 0,
          rate: 0,
          routeName: 'spareGetList'
        }
      ],
      // 备件核心指标概览
      chartsi: [],
      coreList: [
        // {
        //   name: '备件保有率',
        //   num: '90%',
        //   rate: 26,
        //   xdata: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        //   sdata: [10, 15, 5, 17, 12, 16, 8],
        //   areaColor: '#87CEFA',
        //   lineColor: '#00BFFF'
        // },
        {
          name: '平均交付周期（天）',
          num: 0,
          rate: 0,
          xdata: [],
          sdata: [],
          areaColor: '#D4F2E7',
          lineColor: '#90EE90'
        },
        {
          name: '备件满足率',
          num: 0,
          rate: 0,
          xdata: [],
          sdata: [],
          areaColor: '#FAFAD2',
          lineColor: '#F0E68C'
        }
      ],
      core1: {
        xAxis: {
          show: false,
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          show: false,
          type: 'value'
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#000'
            },
            symbol: 'none',
            // labelLine: {
            //   lineStyle: {
            //     color: '#000'
            //   }
            // },
            itemStyle: {
              color: '#1E90FF'
            }
          }
        ]
      },
      // 备件
      sparePart: null,
      sparePartOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          data: ['全网', '个人'],
          bottom: 0,
          left: 'center'
        },
        grid: {
          top: '7px',
          // left: '3%',
          // right: '4%',
          // bottom: '3%',
          containLabel: false
        },
        yAxis: {
          type: 'value'
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: -45,
            default: 0
          },
          data: []
        },
        series: []
      },
      // 分布图
      dataList: [],
      provinceList: [
        {
          name: '北京',
          value: 0
        },
        {
          name: '天津',
          value: 0
        },
        {
          name: '河北',
          value: 0
        },
        {
          name: '山西',
          value: 0
        },
        {
          name: '内蒙古',
          value: 0
        },
        {
          name: '辽宁',
          value: 0
        },
        {
          name: '吉林',
          value: 0
        },
        {
          name: '黑龙江',
          value: 0
        },
        {
          name: '上海',
          value: 0
        },
        {
          name: '江苏',
          value: 0
        },
        {
          name: '浙江',
          value: 0
        },
        {
          name: '安徽',
          value: 0
        },
        {
          name: '福建',
          value: 0
        },
        {
          name: '江西',
          value: 0
        },
        {
          name: '山东',
          value: 0
        },
        {
          name: '河南',
          value: 0
        },
        {
          name: '湖北',
          value: 0
        },
        {
          name: '湖南',
          value: 0
        },
        {
          name: '广东',
          value: 0
        },
        {
          name: '广西',
          value: 0
        },
        {
          name: '海南',
          value: 0
        },
        {
          name: '重庆',
          value: 0
        },
        {
          name: '四川',
          value: 0
        },
        {
          name: '贵州',
          value: 0
        },
        {
          name: '云南',
          value: 0
        },
        {
          name: '西藏',
          value: 0
        },
        {
          name: '陕西',
          value: 0
        },
        {
          name: '甘肃',
          value: 0
        },
        {
          name: '青海',
          value: 0
        },
        {
          name: '宁夏',
          value: 0
        },
        {
          name: '新疆',
          value: 0
        },
        {
          name: '台湾',
          value: 0
        },
        {
          name: '南海诸岛',
          value: 0
        }
      ]
    }
  },
  mounted () {
    this.getSwiperList()
    this.getDataMarket()
    this.getCoreList()
    this.getTopList()
    this.getChinaList()
  },
  methods: {
    // 获取轮播图
    getSwiperList () {
      this.$request
        .get(`/front/user/home/homeRotationChart/carousel/40/true`)
        .then((data) => {
          this.swiperList = data || []
        })
    },
    // 获取数据大盘
    getDataMarket () {
      this.$request
        .postParam(`/front/order/lclb/home/DateMarket`, {
          companyId: this.$store.state.user.defaultCompanyId
        })
        .then((data) => {
          if (data) {
            this.dataMarkets[0].num = data.demand.num
            this.dataMarkets[0].rate = data.demand.rate
            this.dataMarkets[1].num = data.exist.num
            this.dataMarkets[1].rate = data.exist.rate
            this.dataMarkets[2].num = data.use.num
            this.dataMarkets[2].rate = data.use.rate
          }
        })
        .catch(() => {})
    },
    // 备件核心指标
    getCoreList () {
      this.$request
        .postParam(`/front/order/lclb/home/coreView`, {
          companyId: this.$store.state.user.defaultCompanyId
        })
        .then((data) => {
          if (data) {
            this.$nextTick(() => {
              this.coreList.forEach((item, index) => {
                let refName = 'core' + index
                console.log(this.$refs[refName])
                let charti = echarts.getInstanceByDom(this.$refs[refName][0])
                if (charti === undefined) {
                  this.chartsi[index] = echarts.init(this.$refs[refName][0])
                  this.$once('hook:beforeDestroy', function () {
                    echarts.dispose(this.chartsi[index])
                  })
                }
              })
              if (data.avg) {
                this.coreList[0].num = data.avg.num
                this.coreList[0].rate = data.avg.rate
                this.core1.xAxis.data = data.avg.xdata || []
                this.core1.series[0].data = data.avg.sdata || []
                this.core1.series[0].areaStyle.color = this.coreList[0].areaColor
                // this.core1.series[0].labelLine.lineStyle.color = item.lineColor
                this.core1.series[0].itemStyle.color = this.coreList[0].lineColor
                this.chartsi[0].setOption(this.core1)
              }
              if (data.fill) {
                this.coreList[1].num = data.fill.num
                this.coreList[1].rate = data.fill.rate
                this.core1.xAxis.data = data.fill.xdata || []
                this.core1.series[0].data = data.fill.sdata || []
                this.core1.series[0].areaStyle.color = this.coreList[1].areaColor
                // this.core1.series[0].labelLine.lineStyle.color = item.lineColor
                this.core1.series[0].itemStyle.color = this.coreList[1].lineColor
                this.chartsi[1].setOption(this.core1)
              }
            })
          }
        })
        .catch(() => {})
    },
    // 备件Top
    getTopList () {
      this.$request
        .postParam(`/front/order/lclb/home/top10`, {
          companyId: this.$store.state.user.defaultCompanyId
        })
        .then((data) => {
          if (data && data.length > 0) {
            this.$nextTick(() => {
              let sparePart = echarts.getInstanceByDom(this.$refs['sparePart'])
              if (sparePart === undefined) {
                this.sparePart = echarts.init(this.$refs['sparePart'])
                this.$once('hook:beforeDestroy', function () {
                  echarts.dispose(this.sparePart)
                })
              }
              this.sparePartOption.legend.data = data.map((item) => {
                return item.name
              })
              this.sparePartOption.xAxis.data = data[0].xdata
              this.sparePartOption.series = data.map((item, index) => {
                return {
                  name: item.name,
                  type: 'bar',
                  stack: 'total',
                  itemStyle: {
                    color: index === 0 ? '#32CD32' : '#1E90FF'
                  },
                  emphasis: {
                    itemStyle: {
                      color: index === 0 ? '#32CD32' : '#1E90FF'
                    },
                    focus: 'series'
                  },
                  data: item.sdata
                }
              })
              this.sparePart.setOption(this.sparePartOption)
            })
          }
        })
        .catch(() => {})
    },
    // 备件分布
    getChinaList () {
      this.$request
        .postParam(`/front/order/lclb/home/statistics/storeCount`)
        .then((data) => {
          if (data) {
            var reg = new RegExp('省', '')
            var reg1 = new RegExp('市', '')
            var reg2 = new RegExp('自治区', '')
            data.forEach((item) => {
              console.log(item)
              item.name = item.name.replace(reg, '')
              item.name = item.name.replace(reg1, '')
              item.name = item.name.replace(reg2, '')
              let index = this.provinceList.findIndex((pro) => {
                return pro.name === item.name
              })
              if (index > -1) {
                this.provinceList[index].value = item.value
              }
            })
          }
          this.dataList = this.provinceList || []
        })
    },
    jumpRoute (routeName) {
      if (routeName) {
        this.$router.push({
          name: routeName
        })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
.home_page {
  .storeSpare_console {
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.58);
    .lclb_swiper {
      margin-bottom: 20px;
    }
    .lclb_padding {
      padding: 0 0 30px;
      .lclb_title {
        font-size: 18px;
        border-left: 5px solid #2e88ff;
        padding-left: 10px;
        margin-left: 20px;
      }
      .data_market {
        margin-top: 10px;
        border: 1px solid #eee;
        background: #fff;
        border-radius: 3px;
        display: flex;
        height: 152px;
        padding: 20px;
        align-items: center;
        .data_market_img {
          width: 57px;
          height: 57px;
          // border-radius: 57px;
          text-align: center;
          line-height: 57px;
        }
        .data_market_content {
          margin-left: 10px;
          flex-grow: 1;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .market_content_detail {
            flex-shrink: 0;
            width: 20px;
            cursor: pointer;
          }
        }
      }
      .data_market_content_detail {
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        .market_name {
          color: #989898;
          font-weight: 400;
        }
        .market_num {
          font-weight: 500;
          font-size: 32px;
          color: #666666;
        }
        .market_status {
          color: #f04133;
          .market_compare {
            font-weight: 400;
            font-size: 12px;
            color: #cccccc;
          }
        }
        .top-color {
          color: #00a950;
        }
      }
      .box-card {
        margin-top: 20px;
        .core_item {
          padding: 10px;
          border-left: 1px solid #eee;
        }
      }
      .el-card__body .el-row .el-col-12:first-child {
        .core_item {
          border: none;
        }
      }
    }
  }
}
</style>
